//import { SmallUnitRequest } from '../../../../../front-user/services/small-units/shared/models/Small-Unit-Request';

export class SmallUnitService {
    Id: number;
    BaseRequestId: string;
    ServiceName: string;
    // ServiceDate is string to carry the datetime value to avoid converting them to Greenwich time
    ServiceDate: string;
    ServiceDayNight: string;
    ServiceValue: number;
    ServiceDesc: string
}